import focus from './focus';
import scroll from './scroll';
import scrollHash from './scroll-hash';
import anchorTabs from './anchor-tabs';
import hyphens from './hyphens';

export default {
    'focus': focus,
    'scroll': scroll,
    'scroll-hash': scrollHash,
    'anchor-tabs': anchorTabs,
    'hyphens': hyphens,
}
